<template>
	<div>
		<v-card
			:style="{
				paddingTop: !profile.user_flag ? '12px' : '34px',
			}"
			class="short-profile__section"
		>
			<SponsorBadge
				v-if="profile.user_flag"
				:text="profile.user_flag.flag_name"
				:background="profile.user_flag.flag_bg_color"
				:color="profile.user_flag.flag_txt_color"
				top="0"
				right="0"
			/>
			<div class="short-profile__info-wrapper">
				<Avatar
					:avatar="profile.user_logo"
					:size="120"
					border-radius="square"
					class="short-profile__avatar mr-4"
					:defaultAvatar="'speaker'"
					:color="'#ffffff'"
				/>
				<div class="short-profile__info">
					<h1 class="short-profile__info-username text-2-lines">
						{{ profile.visible_username }}
					</h1>
					<div class="d-flex flex-column">
						<span
							v-if="profile.second_profile_row"
							class="short-profile__info-company text-2-lines mb-1"
						>
							{{ profile.second_profile_row }}
						</span>
						<span
							v-if="profile.third_profile_row"
							class="short-profile__info-position text-2-lines"
						>
							{{ profile.third_profile_row }}
						</span>
						<span
							v-if="profile.location_profile_row"
							class="short-profile__info-location text-2-lines"
						>
							<span>{{ profile.location_profile_row }}</span>
						</span>
						<span
							v-if="profile.user_login"
							class="short-profile__info-login text-2-lines"
						>
							{{ profile.user_login }}
						</span>
						<span
							v-if="lastOnlineStatus"
							class="short-profile__info-login text-2-lines"
						>
							{{ lastOnlineStatus }}
						</span>
					</div>
				</div>
			</div>
		</v-card>
		<v-card v-if="isPublicButton" class="personal-profile__section">
			<div @click="toggleToPublicInfo" class="personal-profile__public-button">
				<Icon type="eye" :size="20" :color="'var(--primary_color)'" />
				<span class="personal-profile__public-button__label">View Public Profile</span>
			</div>
		</v-card>
	</div>
</template>
<script>
import Avatar from '@/components/Avatar.vue'
import SponsorBadge from '@/components/SponsorBadge.vue'

export default {
	name: 'ShortProfileCard',
	components: { SponsorBadge, Avatar },
	props: {
		profile: {
			type: Object,
			default: () => ({}),
		},
		isPublicButton: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			now: Math.floor(Date.now() / 1000),
			timer: null,
		}
	},
	computed: {
		lastOnlineStatus() {
			const timestamp = Number(this.profile?.user_last_activity)
			if (!timestamp) return ''

			const diff = this.now - timestamp

			if (diff < 960) return 'Online'

			const minutes = Math.floor(diff / 60)
			if (minutes < 60) return `Last online ${minutes} minutes ago`

			const hours = Math.floor(minutes / 60)
			if (hours < 24) return `Last online ${hours} hours ago`

			const days = Math.floor(hours / 24)
			if (days > 30) return 'Last online long time ago'

			return `Last online ${days} days ago`
		},
	},
	methods: {
		updateNow() {
			this.now = Math.floor(Date.now() / 1000)
		},
		toggleToPublicInfo() {
			return this.$emit('toggleToPublicInfo')
		},
	},
	mounted() {
		this.updateNow()
		this.timer = setInterval(this.updateNow, 1000)
	},
	beforeDestroy() {
		clearInterval(this.timer)
	},
}
</script>

<style lang="scss">
.short-profile {
	background-color: transparent !important;
	&__section {
		max-width: 555px;
		border-radius: 8px !important;
		margin-bottom: 8px;
		border: 1px solid #e2e2e2 !important;
		padding: 12px;
		background-color: #ffffff !important;
		box-shadow: none !important;
	}
	&__info {
		display: flex;
		flex-direction: column;
		font-family: 'Inter', sans-serif;
		width: 100%;
		&-wrapper {
			display: flex;
			flex-wrap: nowrap;

			@media (max-width: 480px) {
				flex-direction: column;
				align-items: center;
			}
		}
		&-username {
			font-size: 24px;
			line-height: 140%;
			font-weight: 700;
			color: var(--username-category-title) !important;
			margin-bottom: 8px;

			@media (max-width: 480px) {
				margin-top: 8px;
				text-align: center;
			}
		}

		&-company {
			font-size: 16px;
			line-height: 140%;
			font-weight: 600;
			color: #4a4a4a;
			width: 100%;
			white-space: normal;
			word-break: break-word;

			@media (max-width: 480px) {
				text-align: center;
			}
		}
		&-position {
			font-size: 16px;
			line-height: 140%;
			font-weight: 400;
			color: #4a4a4a;
			width: 100%;
			white-space: normal;
			word-break: break-word;

			@media (max-width: 480px) {
				text-align: center;
			}
		}
		&-login {
			font-family: 'Inter', sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 140%;
			letter-spacing: 0;
			color: #9b9b9b;
			margin-top: 8px;
		}

		&-location {
			font-size: 13px;
			line-height: 140%;
			font-weight: 500;
			color: var(--location-color);
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
			margin-top: 8px;
			@media (max-width: 480px) {
				justify-content: center;
			}
		}
	}
}
</style>
